import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Shopping"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-shopping',
    templateUrl: './icon-shopping.component.html',
    styleUrls: ['./icon-shopping.component.scss'],
    standalone: false
})
export class IconShoppingComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
